import FullWidthECGPreview from './FullWidthECGPreview';

export default FullWidthECGPreview;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/components/FullWidthECGPreview/index.js